/**
 * The hero greeting clock: HOST-LOCAL time in Arabic-Indic digits, with the
 * day period and zone abbreviation from the same zone.
 *
 * Operator ruling 2026-09-02: host-local, so the greeting and the ring's day
 * marker (zodiacRing.dayAngle, also host-local) agree on every device. It was
 * pinned to America/New_York before; on a phone in another zone the two clocks
 * on one screen disagreed.
 *
 * `timeZone` is an override for tests and for any caller that needs a fixed
 * zone. Omitted, every Intl call uses the host zone.
 */
export function formatHeroTime(date = new Date(), { timeZone } = {}) {
  const zone = timeZone ? { timeZone } : {};

  const arabicParts = new Intl.DateTimeFormat('ar-u-nu-arab', {
    hour: 'numeric', minute: '2-digit', hour12: true, ...zone,
  }).formatToParts(date);
  const hour   = arabicParts.find((p) => p.type === 'hour')?.value   ?? '';
  const minute = arabicParts.find((p) => p.type === 'minute')?.value ?? '';

  const dayPeriod = new Intl.DateTimeFormat('en-US', { hour: 'numeric', hour12: true, ...zone })
    .formatToParts(date).find((p) => p.type === 'dayPeriod')?.value ?? '';

  const tzAbbr = new Intl.DateTimeFormat('en-US', { timeZoneName: 'short', ...zone })
    .formatToParts(date).find((p) => p.type === 'timeZoneName')?.value ?? '';

  return `${hour}:${minute} ${dayPeriod} ${tzAbbr}`;
}
